import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import {PhoneInput} from "react-international-phone";
import toast from "react-hot-toast";
import Papa from "papaparse";
import {Tab, TabGroup, TabList, TabPanel, TabPanels} from "@headlessui/react";
import {PhoneNumberUtil} from "google-libphonenumber";
import {
  getZone,
  isAbujaPickupWithInvalidDeliveries,
  isLagosPickupWithInvalidDeliveries,
  isLocationNotAccepted,
  isLocationNotAcceptedWithoutArray,
  LocationsNotCoveredInLagos,
} from "../utils/zone";
import {AddressInput} from "./AddressInput";
import {Input, Textarea} from "./FormsInput";
import * as XLSX from "xlsx";
import {Link} from "react-router-dom";

const BigDocs = () => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.33301 29.0346V3.96797C5.33301 3.52614 5.69118 3.16797 6.13301 3.16797H21.6683C21.8805 3.16797 22.084 3.25225 22.234 3.40228L26.432 7.60032C26.5821 7.75035 26.6663 7.95383 26.6663 8.16601V29.0346C26.6663 29.4765 26.3082 29.8346 25.8663 29.8346H6.13301C5.69118 29.8346 5.33301 29.4765 5.33301 29.0346Z"
      stroke="#36394A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.667 13.832L21.3337 13.832"
      stroke="#36394A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.667 24.5L21.3337 24.5"
      stroke="#36394A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.667 19.168L16.0003 19.168"
      stroke="#36394A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M21.333 3.16797V7.7013C21.333 8.14313 21.6912 8.5013 22.133 8.5013H26.6663"
      stroke="#36394A"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const CopyBlack = () => (
  <svg
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.4 20.5H9.6C9.26863 20.5 9 20.2314 9 19.9V10.1C9 9.76863 9.26863 9.5 9.6 9.5H19.4C19.7314 9.5 20 9.76863 20 10.1V19.9C20 20.2314 19.7314 20.5 19.4 20.5Z"
      stroke="#36394A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 9.5V5.1C15 4.76863 14.7314 4.5 14.4 4.5H4.6C4.26863 4.5 4 4.76863 4 5.1V14.9C4 15.2314 4.26863 15.5 4.6 15.5H9"
      stroke="#36394A"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const Download = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3C13 2.44772 12.5523 2 12 2C11.4477 2 11 2.44772 11 3V12.5858L7.70711 9.29289C7.31658 8.90237 6.68342 8.90237 6.29289 9.29289C5.90237 9.68342 5.90237 10.3166 6.29289 10.7071L11.2929 15.7071C11.6834 16.0976 12.3166 16.0976 12.7071 15.7071L17.7071 10.7071C18.0976 10.3166 18.0976 9.68342 17.7071 9.29289C17.3166 8.90237 16.6834 8.90237 16.2929 9.29289L13 12.5858V3Z"
      fill="#FE7F1F"
    />
    <path
      d="M3 14C3.55229 14 4 14.4477 4 15V16.2C4 17.0566 4.00078 17.6389 4.03755 18.089C4.07337 18.5274 4.1383 18.7516 4.21799 18.908C4.40973 19.2843 4.7157 19.5903 5.09202 19.782C5.24842 19.8617 5.47262 19.9266 5.91104 19.9624C6.36113 19.9992 6.94342 20 7.8 20H16.2C17.0566 20 17.6389 19.9992 18.089 19.9624C18.5274 19.9266 18.7516 19.8617 18.908 19.782C19.2843 19.5903 19.5903 19.2843 19.782 18.908C19.8617 18.7516 19.9266 18.5274 19.9624 18.089C19.9992 17.6389 20 17.0566 20 16.2V15C20 14.4477 20.4477 14 21 14C21.5523 14 22 14.4477 22 15V16.2413C22 17.0463 22 17.7106 21.9558 18.2518C21.9099 18.8139 21.8113 19.3306 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C19.3306 21.8113 18.8139 21.9099 18.2518 21.9558C17.7106 22 17.0463 22 16.2413 22H7.7587C6.95373 22 6.28937 22 5.74818 21.9558C5.18608 21.9099 4.66937 21.8113 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43598 19.816C2.18868 19.3306 2.09012 18.8139 2.04419 18.2518C1.99998 17.7106 1.99999 17.0463 2 16.2413V15C2 14.4477 2.44772 14 3 14Z"
      fill="#FE7F1F"
    />
  </svg>
);

const ErrorInfo = () => (
  <svg
    width="14"
    height="15"
    viewBox="0 0 14 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4.83333V7.5M7 10.1667H7.00667M1 7.5C1 8.28793 1.15519 9.06815 1.45672 9.7961C1.75825 10.5241 2.20021 11.1855 2.75736 11.7426C3.31451 12.2998 3.97595 12.7417 4.7039 13.0433C5.43185 13.3448 6.21207 13.5 7 13.5C7.78793 13.5 8.56815 13.3448 9.2961 13.0433C10.0241 12.7417 10.6855 12.2998 11.2426 11.7426C11.7998 11.1855 12.2417 10.5241 12.5433 9.7961C12.8448 9.06815 13 8.28793 13 7.5C13 5.9087 12.3679 4.38258 11.2426 3.25736C10.1174 2.13214 8.5913 1.5 7 1.5C5.4087 1.5 3.88258 2.13214 2.75736 3.25736C1.63214 4.38258 1 5.9087 1 7.5Z"
      stroke="#DF1C41"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const OrderEdit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3 21L12 21H21"
      stroke="#fe7f1f"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2218 5.8279L15.0503 2.99947L20 7.94922L17.1716 10.7776M12.2218 5.8279L6.61522 11.4345C6.42769 11.622 6.32233 11.8764 6.32233 12.1416L6.32233 16.6771L10.8579 16.6771C11.1231 16.6771 11.3774 16.5718 11.565 16.3842L17.1716 10.7776M12.2218 5.8279L17.1716 10.7776"
      stroke="#fe7f1f"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const SmallDocs = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33333 2H4C3.44772 2 3 2.44772 3 3V13C3 13.5523 3.44772 14 4 14H12C12.5523 14 13 13.5523 13 13V5.33333M9.33333 2L13 5.33333M9.33333 2V5.33333H13"
      stroke="#667085"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TickEmpty = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#D0D5DD" />
  </svg>
);

const TickSuccess = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="20" height="20" rx="10" fill="#039855" />
    <path
      d="M14.6666 6.5L8.24992 12.9167L5.33325 10"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Trash = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H14M12.6667 4V13.3333C12.6667 14.0697 12.0697 14.6667 11.3333 14.6667H4.66667C3.93029 14.6667 3.33333 14.0697 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 1.93029 5.93029 1.33333 6.66667 1.33333H9.33333C10.0697 1.33333 10.6667 1.93029 10.6667 2.66667V4"
      stroke="#1D2939"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const TrashLight = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 4H14M12.6667 4V13.3333C12.6667 14.0697 12.0697 14.6667 11.3333 14.6667H4.66667C3.93029 14.6667 3.33333 14.0697 3.33333 13.3333V4M5.33333 4V2.66667C5.33333 1.93029 5.93029 1.33333 6.66667 1.33333H9.33333C10.0697 1.33333 10.6667 1.93029 10.6667 2.66667V4"
      stroke="#D92D20"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

interface DeliveryDetailsProps {
  values: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setFieldValue: any;
  setFieldTouched: any;
  initialValues: any;
  getEstimate: () => Promise<void>;
  isLoading: boolean;
  isCheckoutLoading: boolean;
  isAdmin?: boolean; // Add admin flag
}

interface DeliveryDetailsRef {
  scrollToDelivery: (index: number) => void;
}

export const DeliveryDetails = forwardRef<
  DeliveryDetailsRef,
  DeliveryDetailsProps
>(
  (
    {
      handleBlur,
      handleChange,
      values,
      errors,
      touched,
      setStep,
      step,
      setFieldValue,
      setFieldTouched,
      initialValues,
      getEstimate,
      isLoading,
      isCheckoutLoading,
      isAdmin = false, // Default to false
    },
    ref
  ) => {
    const deliveryRefs = useRef<(HTMLDivElement | null)[]>([]);
    const [uploadedDeliveries, setUploadedDeliveries] = useState(false);
    const [results, setResults] = useState<{
      valid: any[];
      invalid: any[];
    } | null>(null);

    const [totalCount, setTotalCount] = useState<number>(0);
    const [totalValid, setTotalValid] = useState<number>(0);
    const [totalInvalid, setTotalInvalid] = useState<number>(0);
    const [activeTab, setActiveTab] = useState<"valid" | "invalid">("valid");
    const [statusMessage, setStatusMessage] = useState<string>("");
    const [uploadProgress, setUploadProgress] = useState<number>(0);
    const [editingIndex, setEditingIndex] = useState<number | null>(null);
    const [editingAddress, setEditingAddress] = useState<any>(null);
    const [editingType, setEditingType] = useState<"valid" | "invalid" | null>(
      null
    );

    useEffect(() => {
      if (editingAddress && editingType === "invalid") {
        const phoneNumber = editingAddress["Phone Number"] || "";
        if (phoneNumber && !phoneNumber.startsWith("+")) {
          setEditingAddress({
            ...editingAddress,
            "Phone Number": `+${phoneNumber}`,
          });
        }
      }
    }, [editingAddress, editingType]);
    useImperativeHandle(ref, () => ({
      scrollToDelivery: (index: number) => {
        deliveryRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      },
    }));
    const [orderType, setOrderType] = useState("manual");

    const validatePhoneNumber = (
      phoneNumber: string,
      countryCode: string = "NG"
    ) => {
      try {
        const phoneUtil = PhoneNumberUtil.getInstance();
        const formattedValue = phoneNumber.startsWith("+")
          ? phoneNumber
          : `+${phoneNumber}`;

        const number = phoneUtil.parse(formattedValue, countryCode);
        return phoneUtil.isValidNumber(number);
      } catch (error) {
        return false;
      }
    };

    const [phoneError, setPhoneError] = useState<string>("");

    const assignValues = async () => {
      if (results?.valid && results.valid.length > 0) {
        let schedule: string;
        if (
          values.pickupTime === "7am - 8:30am" &&
          values.accountType === "WITHIN_LAGOS"
        ) {
          schedule = "Same Day";
        } else if (
          values.pickupTime === "8:30am - 10am" &&
          values.accountType === "WITHIN_LAGOS"
        ) {
          schedule = "Next Day";
        } else if (values.accountType === "OUTSIDE_LAGOS") {
          schedule = "3 - 5 Business Days";
        } else if (values.accountType === "OUTSIDE_NIGERIA") {
          schedule = "5 - 7 Business Days";
        }

        const mappedDeliveries = results.valid.map((address: any) => ({
          full_name: address["Full Name"] || "",
          d_address: address.Address || address.formatted_address || "",
          d_state: address.State || "",
          d_state_b: address.Country || "",
          d_city: address.City || "",
          d_schedule: schedule || "3 - 5 Business Days",
          d_phone_number: address["Phone Number"] || "",
          d_weight: address["Product Weight"] || address.Weight || "",
          email: address.Email.trim() || "",
          d_description: address["Item Description & Instruction"] || "",
          latitude: address.latitude || 0,
          longitude: address.longitude || 0,
          timezone: address.timezone?.toString() || "",
          amount: address["Amount"],
          zone: address.zone || "",
        }));

        // Set the mapped deliveries to Formik
        await setFieldValue("deliveries", mappedDeliveries);
      }
    };

    const validateDeliveries = async () => {
      if (values.orderType === "BATCH_ORDER" && orderType === "import") {
        // Check if there are any invalid deliveries
        if (results?.invalid && results.invalid.length > 0) {
          toast.error(
            "You still have invalid deliveries. Validate/delete them to continue"
          );
          return false;
        }
        return true;
      }

      for (let i = 0; i < values.deliveries.length; i++) {
        const delivery = values.deliveries[i];
        const requiredFields = [
          {name: "full_name", label: "full name"},
          {name: "d_address", label: "address"},
          {name: "d_state", label: "state"},
          {name: "d_city", label: "city"},
          {name: "d_phone_number", label: "phone number"},
          {name: "d_weight", label: "product weight"},
          {name: "d_description", label: "description"},
        ];

        for (const field of requiredFields) {
          // Special validation for phone number (min 13 characters)
          if (field.name === "d_phone_number") {
            if (!delivery[field.name]) {
              toast.error(
                `Delivery ${i + 1}: Please enter a valid ${field.label}`
              );
              deliveryRefs.current[i]?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
              return false;
            }
            if (errors.deliveries?.[i]?.[field.name]) {
              toast.error(
                `Delivery ${i + 1}: ${errors.deliveries[i][field.name]}`
              );
              deliveryRefs.current[i]?.scrollIntoView({
                behavior: "smooth",
                block: "start",
              });
              return false;
            }
            continue;
          }

          if (!delivery[field.name]) {
            toast.error(`Delivery ${i + 1}: Please fill in ${field.label}`);
            deliveryRefs.current[i]?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return false;
          }

          if (errors.deliveries?.[i]?.[field.name]) {
            toast.error(
              `Delivery ${i + 1}: ${errors.deliveries[i][field.name]}`
            );
            deliveryRefs.current[i]?.scrollIntoView({
              behavior: "smooth",
              block: "start",
            });
            return false;
          }
        }

        // // Check coordinates
        // if (Number(delivery.latitude) <= 0 || Number(delivery.longitude) <= 0) {
        //   toast.error(`Delivery ${i + 1}: Please select a valid address`);
        //   deliveryRefs.current[i]?.scrollIntoView({
        //     behavior: "smooth",
        //     block: "start",
        //   });
        //   return false;
        // }
      }

      return true;
    };

    useEffect(() => {
      if (
        results?.valid &&
        results.valid.length > 0 &&
        orderType === "import"
      ) {
        assignValues();
      }
    }, [results, orderType]);

    const addDelivery = () => {
      const newDelivery = {
        full_name: "",
        d_address: "",
        d_state: "",
        d_city: "",
        d_schedule: "3 - 5 Business Days",
        deliveryType: null,
        d_phone_number: "",
        d_weight: "",
        email: "",
        d_description: "",
        latitude: 0,
        longitude: 0,
        timezone: "",
      };
      setFieldValue("deliveries", [...values.deliveries, newDelivery]);
    };

    const duplicateDelivery = () => {
      if (values.deliveries.length === 0) return;

      // Get the last delivery
      const lastDelivery = values.deliveries[values.deliveries.length - 1];
      const duplicatedDelivery = {
        full_name: lastDelivery.full_name,
        d_address: lastDelivery.d_address,
        d_state: lastDelivery.d_state,
        d_city: lastDelivery.d_city,
        d_schedule: lastDelivery.d_schedule,
        deliveryType: lastDelivery.deliveryType,
        d_phone_number: lastDelivery.d_phone_number,
        email: lastDelivery.email,
        d_weight: lastDelivery.d_weight,
        d_description: lastDelivery.d_description,
        latitude: lastDelivery.latitude,
        longitude: lastDelivery.longitude,
        timezone: lastDelivery.timezone,
      };

      // Add the duplicated delivery to the array
      setFieldValue("deliveries", [...values.deliveries, duplicatedDelivery]);
    };

    const removeDelivery = (index: number) => {
      if (values.deliveries.length > 1) {
        const updatedDeliveries = [...values.deliveries];
        updatedDeliveries.splice(index, 1);
        setFieldValue("deliveries", updatedDeliveries);
      }
    };

    const getFieldError = (index: number, fieldName: string) => {
      return errors.deliveries?.[index]?.[fieldName] &&
        touched.deliveries?.[index]?.[fieldName]
        ? errors.deliveries[index][fieldName]
        : null;
    };

    const isAnyDeliveryLocationNotAccepted = (deliveries: any) => {
      if (!deliveries || deliveries.length === 0) {
        return true;
      }

      for (const delivery of deliveries) {
        if (
          !delivery.d_city ||
          isLocationNotAcceptedWithoutArray(delivery.d_city, values.accountType)
        ) {
          return true;
        }
      }
      return false;
    };

    const handleEstimateClick = async () => {
      // First validate all deliveries
      const check = await validateDeliveries();
      if (!check) {
        return;
      }
      console.log(values);
      if (isAbujaPickupWithInvalidDeliveries(values.state, values.deliveries)) {
        toast.error(
          "If pickup is from Abuja, deliveries are only allowed within Lagos."
        );
        return;
      }

      if (
        values.accountType === "OUTSIDE_LAGOS" &&
        values.state.toLowerCase().includes("lagos") &&
        isLagosPickupWithInvalidDeliveries(values.state, values.deliveries)
      ) {
        toast.error(
          "If pickup is from Lagos, deliveries are only allowed outside Lagos."
        );
        return;
      }
      // Check for location coverage
      const anyNotAccepted = isAnyDeliveryLocationNotAccepted(
        values.deliveries
      );
      if (anyNotAccepted) {
        toast.error(
          "Delivery is not available to one or more selected locations. Please review your delivery cities."
        );
        return;
      }

      // Check for failed geocodes
      const failedGeocodes = values.deliveries.filter(
        (delivery: any) =>
          delivery._geocodeWarning &&
          (!delivery.latitude ||
            !delivery.longitude ||
            !delivery.timezone ||
            !delivery.d_state ||
            !delivery.d_city) &&
          (delivery._geocodeWarning.includes("Could not find") ||
            delivery._geocodeWarning.includes("Service not available"))
      );

      console.log(failedGeocodes, values);

      if (failedGeocodes.length > 0) {
        toast.error(
          `${failedGeocodes.length} addresses need to be resolved before proceeding. Please fix the address issues or use the "Retry Failed Addresses" button.`
        );
        return;
      }

      // If all validations pass, proceed with estimate
      await getEstimate();
    };

    const getTimezoneOffset = async (
      lat: number,
      lng: number
    ): Promise<any> => {
      const API_KEY = process.env.REACT_APP_GM_TIMEZONE_API_KEY;
      const timestamp = Math.floor(Date.now() / 1000);

      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/timezone/json?location=${lat},${lng}&timestamp=${timestamp}&key=${API_KEY}`
        );

        const data = await response.json();

        if (data.status === "OK") {
          return (data.rawOffset + data.dstOffset) / 60;
        } else {
          throw new Error(`Timezone lookup failed: ${data.status}`);
        }
      } catch (error: any) {
        throw new Error(`Timezone API error: ${error.message}`);
      }
    };

    const geocodeAddress = async (addressString: string): Promise<any> => {
      if (!window.google?.maps?.Geocoder) {
        throw new Error("Google Maps Geocoder not available");
      }

      const geocoder = new google.maps.Geocoder();

      return new Promise((resolve, reject) => {
        geocoder.geocode({address: addressString}, async (results, status) => {
          if (status === "OK" && results && results[0]) {
            const addressComponents = results[0].address_components;
            const formattedAddress = results[0].formatted_address;
            const location = results[0].geometry?.location;

            const addressData: any = {
              formatted_address: formattedAddress,
            };

            if (location) {
              addressData.latitude = location.lat();
              addressData.longitude = location.lng();

              try {
                const timezoneInfo = await getTimezoneOffset(
                  addressData.latitude,
                  addressData.longitude
                );
                addressData.timezone = timezoneInfo;
              } catch (timezoneError: any) {
                console.warn("Timezone lookup failed:", timezoneError);
                addressData.timezone = {error: timezoneError.message};
              }
            }

            addressComponents.forEach((component) => {
              const types = component.types;
              if (types.includes("street_number"))
                addressData.Street = component.long_name;
              else if (types.includes("route"))
                addressData.Street = addressData.Street
                  ? `${addressData.Street} ${component.long_name}`
                  : component.long_name;
              else if (types.includes("locality"))
                addressData.City = component.long_name;
              else if (types.includes("administrative_area_level_1"))
                addressData.State = component.long_name;
              else if (types.includes("country"))
                addressData.Country = component.long_name;
              else if (types.includes("postal_code"))
                addressData.PostalCode = component.long_name;
            });

            resolve(addressData);
          } else {
            reject(new Error(`Geocoding failed: ${status}`));
          }
        });
      });
    };

    const validateAddress = async (
      address: any,
      scenario: string,
      accountType?: string,
      weight?: number
    ) => {
      let addressData = address;

      // If address is a string, geocode it first
      if (typeof address === "string") {
        try {
          addressData = await geocodeAddress(address);
        } catch (error: any) {
          return {
            isValid: false,
            reason:
              !address || address.length < 1
                ? "No address provided"
                : `Failed to geocode address: ${error.message}`,
            originalAddress: address,
          };
        }
      }

      const addressState = addressData.State ? addressData.State.trim() : "";
      const addressCity = addressData.City ? addressData.City.trim() : "";
      const addressCountry = addressData.Country
        ? addressData.Country.trim()
        : "";

      const addressText =
        addressData.Address ||
        addressData.address ||
        addressData.formatted_address ||
        "";

      let isValid = false;
      let reason = "";

      if (!addressText.trim()) {
        return {isValid: false, reason: "Address is required", addressData};
      }

      if (!weight || Number(weight) <= 0) {
        return {
          isValid: false,
          reason: "Valid Weight is required",
          addressData,
        };
      }

      // First, validate basic scenario using your getZone function
      switch (scenario) {
        case "within-lagos":
          // Use getZone to validate WITHIN_LAGOS (should return "Zone 1" for Lagos)
          const lagosZone = getZone("WITHIN_LAGOS", addressState);

          // Check if address contains any locations not covered in Lagos
          const containsUncoveredLocation =
            LocationsNotCoveredInLagos.includes(addressCity);

          if (lagosZone === "Zone 1" && !containsUncoveredLocation) {
            isValid = true;
          } else if (containsUncoveredLocation) {
            const foundLocation = LocationsNotCoveredInLagos.find(
              (location) =>
                addressText
                  .toLowerCase()
                  .includes(`${location.toLowerCase()} `) ||
                addressText.toLowerCase().includes(`${location.toLowerCase()},`)
            );
            reason = `Address is in a location not covered by our Lagos service: '${foundLocation}'`;
          } else {
            reason = `Address is not in Lagos. Found State: '${addressState}'`;
          }
          break;

        case "outside-lagos":
          // Use getZone to validate OUTSIDE_LAGOS
          const outsideLagosZone = getZone(
            "OUTSIDE_LAGOS",
            addressCity || addressState
          );
          if (outsideLagosZone) {
            isValid = true;
          } else {
            reason = `Address is not in a serviceable area outside Lagos. Found City: '${addressCity}', State: '${addressState}'`;
          }
          break;

        case "outside-nigeria":
          // Use getZone to validate OUTSIDE_NIGERIA
          const internationalZone = getZone("OUTSIDE_NIGERIA", addressCountry);
          if (internationalZone) {
            isValid = true;
          } else {
            reason = `Address is not in a serviceable country outside Nigeria. Found Country: '${addressCountry}'`;
          }
          break;

        default:
          reason = `Unknown validation scenario: ${scenario}`;
      }

      // Check weight validation for specific areas (10kg limit)
      if (isValid && accountType === "OUTSIDE_LAGOS" && weight) {
        const upperCity = addressCity.toUpperCase();
        const upperState = addressState.toUpperCase();

        // const is10kgArea =
        //   upperCity === "IBADAN" ||
        //   upperCity === "PORT HARCOURT" ||
        //   upperCity === "ABUJA" ||
        //   upperCity === "FEDERAL CAPITAL TERRITORY" ||
        //   upperState === "LAGOS" ||
        //   upperCity === "LAGOS";

        // if (is10kgArea && Number(weight) > 10) {
        //   isValid = false;
        //   reason = "Maximum weight for the selected delivery location is 10kg!";
        // }
      }

      // General weight validation (15kg limit for all other areas)
      //   if (isValid && weight && Number(weight) > 15) {
      //     isValid = false;
      //     reason = "Weight above 15kg is not allowed";
      //   }

      return {isValid, reason, addressData};
    };

    const handleFileChange = async (e: any) => {
      const file = e.target.files?.[0];
      if (!file) return;

      const fileType = file.name.split(".").pop()?.toLowerCase();
      if (!["xlsx", "csv"].includes(fileType)) {
        toast.error("Only .xlsx and .csv files are supported");
        return;
      }

      const reader = new FileReader();

      reader.onprogress = (e) => {
        if (e.lengthComputable) {
          const percent = (e.loaded / e.total) * 100;
          setUploadProgress(percent);
        }
      };

      reader.onload = async (e: any) => {
        try {
          let jsonData: any[] = [];

          if (fileType === "xlsx") {
            const data = new Uint8Array(e.target.result!);
            const workbook = XLSX.read(data, {type: "array"});
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            jsonData = XLSX.utils.sheet_to_json(sheet, {defval: ""});
          } else if (fileType === "csv") {
            const csvText = e.target.result;
            const results = await new Promise<any>((resolve) => {
              Papa.parse(csvText, {
                header: true,
                skipEmptyLines: true,
                complete: (results: any) => resolve(results),
              });
            });
            jsonData = results.data;
          }

          console.log("Processing", jsonData.length, "rows from file");

          let validationScenario = "";
          if (values.accountType === "WITHIN_LAGOS") {
            validationScenario = "within-lagos";
          } else if (values.accountType === "OUTSIDE_LAGOS") {
            validationScenario = "outside-lagos";
          } else if (values.accountType === "OUTSIDE_NIGERIA") {
            validationScenario = "outside-nigeria";
          }

          // Validate addresses with geocoding
          const validAddresses: any[] = [];
          const invalidAddresses: any[] = [];

          // Process addresses sequentially to avoid API rate limits
          for (const item of jsonData) {
            try {
              let phoneError = "";
              if (!item["Phone Number"]?.trim()) {
                phoneError = "Phone Number is required";
              } else {
                const isPhoneValid = validatePhoneNumber(item["Phone Number"]);
                if (!isPhoneValid) {
                  phoneError = "Invalid phone number format";
                }
              }

              if (phoneError) {
                invalidAddresses.push({
                  ...item,
                  _validationError: phoneError,
                });
                continue; // Skip address validation if phone is invalid
              }
              // Assuming your CSV has an 'Address' column
              const addressString =
                item.Address || item.address || JSON.stringify(item);

              const validationResult = await validateAddress(
                addressString,
                validationScenario,
                values.accountType,
                item["Product Weight"] || item.weight || item.d_weight
              );

              if (item["Full Name"] === "" || !item["Full Name"]) {
                invalidAddresses.push({
                  ...item,
                  Email: item.Email.trim(),
                  ...validationResult.addressData,
                  _validationError: "Full Name is required",
                });
              } else if (item["Phone Number"] === "" || !item["Phone Number"]) {
                invalidAddresses.push({
                  ...item,
                  ...validationResult.addressData,
                  _validationError: "Phone Number is required",
                });
              } else if (
                item["Item Description & Instruction"] === "" ||
                !item["Item Description & Instruction"]
              ) {
                invalidAddresses.push({
                  ...item,
                  ...validationResult.addressData,
                  _validationError:
                    "Item Description & Instruction is required",
                });
              } else if (
                Number(item["Amount"]) < 1 ||
                item === "" ||
                !item["Amount"]
              ) {
                invalidAddresses.push({
                  ...item,
                  ...validationResult.addressData,
                  _validationError:
                    "Amount is required and must be greater than 0",
                });
              } else if (validationResult.isValid) {
                validAddresses.push({
                  ...item,
                  ...validationResult.addressData,
                  zone: getZone(
                    values.accountType,
                    values.accountType === "OUTSIDE_NIGERIA"
                      ? validationResult.addressData.Country
                      : values.accountType === "OUTSIDE_LAGOS"
                      ? validationResult.addressData.City
                      : validationResult.addressData.State
                  ),
                });
              } else {
                invalidAddresses.push({
                  ...item,
                  ...validationResult.addressData,
                  _validationError: validationResult.reason,
                });
              }
            } catch (error: any) {
              invalidAddresses.push({
                ...item,
                _validationError: `Adress Invalid!`,
              });
            }

            // Add delay to avoid hitting rate limits
            await new Promise((resolve) => setTimeout(resolve, 100));
          }

          // Set results for tabs
          setResults({
            valid: validAddresses,
            invalid: invalidAddresses,
          });
          console.log(validAddresses);
          setUploadedDeliveries(true);
          setTotalCount(jsonData.length);
          setTotalValid(validAddresses.length);
          setTotalInvalid(invalidAddresses.length);

          // Set active tab based on results
          if (validAddresses.length > 0) {
            setActiveTab("valid");
          } else if (invalidAddresses.length > 0) {
            setActiveTab("invalid");
          }

          setStatusMessage(
            `Processed ${jsonData.length} addresses. Found ${validAddresses.length} valid and ${invalidAddresses.length} invalid.`
          );
          setUploadProgress(0);

          toast.success(
            `Validation complete. ${validAddresses.length} valid, ${invalidAddresses.length} invalid addresses.`
          );
        } catch (error) {
          console.error("Error processing file:", error);
          toast.error(
            "Error processing file. Please check the format and try again."
          );
          setUploadProgress(0);
        }
      };

      if (fileType === "xlsx") {
        reader.readAsArrayBuffer(file);
      } else if (fileType === "csv") {
        reader.readAsText(file);
      }
    };

    const downloadInvalidCSV = (invalidDeliveries: any[]) => {
      const headers = [
        "S/N",
        "Full Name",
        "Address",
        "City",
        "State",
        "Email",
        "Phone Number",
        "Product Weight",
        "Item Description & Instruction",
        "Amount",
      ];

      // Map invalid deliveries to CSV rows
      const rows = invalidDeliveries.map((delivery, index) => [
        index + 1, // S/N
        delivery["Full Name"] || "",
        delivery.Address || "",
        delivery.City || "",
        delivery.State || "",
        delivery.Email || "",
        delivery["Phone Number"] || "",
        delivery["Product Weight"] || "",
        delivery.Note || delivery["Item Description & Instruction"] || "",
        delivery["Amount"] || "",
      ]);

      // Combine headers and rows
      const csvContent = [headers, ...rows]
        .map((row) =>
          row
            .map((field) => `"${field.toString().replace(/"/g, '""')}"`)
            .join(",")
        )
        .join("\n");

      // Create a Blob and download link
      const blob = new Blob([csvContent], {type: "text/csv;charset=utf-8;"});
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", "invalid_addresses.csv");
      link.style.visibility = "hidden";

      // Trigger download
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    const fileData: any = {
      WITHIN_LAGOS: {
        path: "/eFTD_Sample_Ship_within_Lagos_-_Sheet1.csv",
        name: "eFTD_Sample_Ship_within_Lagos_-_Sheet1.csv",
        label: "Within Lagos",
      },
      OUTSIDE_LAGOS: {
        path: "/eFTD_Sample_Ship_outside_Lagos_-_Sheet1.csv",
        name: "eFTD_Sample_Ship_outside_Lagos_-_Sheet1.csv",
        label: "Outside Lagos",
      },
      OUTSIDE_NIGERIA: {
        path: "/eFTD_Sample_Ship_outside_Nigeria_-_Sheet1.csv",
        name: "eFTD_Sample_Ship_outside_Nigeria_-_Sheet1.csv",
        label: "Outside Nigeria",
      },
    };
    return (
      <div className="w-full border border-gray-100 p-3 md:py-4 md:px-8 rounded-[20px] relative">
        <p className="font-semibold text-greyscale-700">
          Delivery Details
          {step > 2 && (
            <button
              onClick={() => {
                setStep(2);
              }}
              className="ml-2"
            >
              <OrderEdit />
            </button>
          )}
        </p>

        <div className="absolute top-3 md:top-4 lg:top-5 right-6">
          {step < 3 ? <TickEmpty /> : <TickSuccess />}
        </div>

        {step === 2 && (
          <>
            <h2 className="text-sm text-greyscale-600 mb-2 mt-8">
              Account Type
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <label className="flex items-center gap-3 border border-gray-100 h-[50px] px-5 rounded-[10px] cursor-pointer relative">
                <input
                  type="radio"
                  name="orderType"
                  value="SINGLE_ORDER"
                  checked={values.orderType === "SINGLE_ORDER"}
                  onChange={() => {
                    setFieldValue("orderType", "SINGLE_ORDER");
                    setOrderType("manual");
                    if (values.deliveries.length > 1) {
                      setFieldValue("deliveries", [values.deliveries[0]]);
                    }
                  }}
                  onBlur={handleBlur}
                  className="absolute opacity-0 h-0 w-0"
                />
                <div
                  className={`absolute top-3.5 left-3 h-5 w-5 rounded-full border-2 ${
                    values.orderType === "SINGLE_ORDER"
                      ? "border-[#fe7f1f] bg-[#fe7f1f]"
                      : "border-gray-100"
                  }`}
                >
                  {values.orderType === "SINGLE_ORDER" && (
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full" />
                  )}
                </div>
                <span className="text-greyscale-500 ml-5 text-sm">
                  Single Delivery
                </span>
              </label>

              <label className="flex items-center gap-3 border border-gray-100 h-[50px] px-5 rounded-[10px] cursor-pointer relative">
                <input
                  type="radio"
                  name="orderType"
                  value="BATCH_ORDER"
                  checked={values.orderType === "BATCH_ORDER"}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className="absolute opacity-0 h-0 w-0"
                />
                <div
                  className={`absolute top-3.5 left-3 h-5 w-5 rounded-full border-2 ${
                    values.orderType === "BATCH_ORDER"
                      ? "border-[#fe7f1f] bg-[#fe7f1f]"
                      : "border-gray-100"
                  }`}
                >
                  {values.orderType === "BATCH_ORDER" && (
                    <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-white rounded-full" />
                  )}
                </div>
                <span className="text-greyscale-500 ml-5 text-sm">
                  Multiple Deliveries
                </span>
              </label>
            </div>

            <div className="w-full border-b border-b-gray-100 my-8" />

            {values.orderType === "BATCH_ORDER" && (
              <div className="mb-8 grid grid-cols-2 gap-4">
                <button
                  onClick={() => {
                    setOrderType("manual");
                    setFieldValue("batchOrderType", "MANUAL_UPLOAD");
                  }}
                  className="flex items-center gap-3 border border-gray-100 h-[50px] px-5 rounded-[10px] cursor-pointer relative"
                >
                  <div
                    className={`h-5 w-5 rounded-full border-2 flex items-center justify-center ${
                      orderType === "manual"
                        ? "border-[#fe7f1f] bg-[#fe7f1f]"
                        : "border-gray-100"
                    }`}
                  >
                    <div className=" w-2 h-2 bg-white rounded-full" />
                  </div>
                  <p className="text-greyscale-500 text-sm">Manual Entry</p>
                </button>
                <button
                  onClick={() => {
                    setOrderType("import");
                    setFieldValue("batchOrderType", "IMPORT_ORDER");
                  }}
                  className="flex items-center gap-3 border border-gray-100 h-[50px] px-5 rounded-[10px] cursor-pointer relative"
                >
                  <div
                    className={`h-5 w-5 rounded-full border-2 flex items-center justify-center ${
                      orderType === "import"
                        ? "border-[#fe7f1f] bg-[#fe7f1f]"
                        : "border-gray-100"
                    }`}
                  >
                    <div className=" w-2 h-2 bg-white rounded-full" />
                  </div>
                  <p className="text-greyscale-500 text-sm">Bulk uploads</p>
                </button>
              </div>
            )}

            {orderType === "manual" ? (
              <>
                {values.deliveries.map((delivery: any, index: number) => (
                  <div
                    key={index}
                    className="mb-8 relative"
                    ref={(el) => {
                      deliveryRefs.current[index] = el;
                    }}
                  >
                    {values.orderType === "BATCH_ORDER" && (
                      <div className="flex justify-between items-center mb-4">
                        <h3 className="font-medium text-greyscale-700">
                          Delivery {index + 1}
                        </h3>
                      </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
                      <Input
                        type="text"
                        name={`deliveries[${index}].full_name`}
                        label="Full Name"
                        placeholder="Enter name here"
                        value={delivery.full_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={getFieldError(index, "full_name")}
                      />

                      <AddressInput
                        name={`deliveries[${index}].d_address`}
                        label="Address"
                        regionScope={
                          values.accountType === "OUTSIDE_NIGERIA"
                            ? "international"
                            : "nigeria"
                        }
                        placeholder="Search your address"
                        onPlaceSelected={(place) => {
                          console.log("Place object:", place);

                          // First set the address
                          setFieldValue(
                            `deliveries[${index}].d_address`,
                            place.formatted_address || ""
                          );

                          // Then handle the location and components
                          if (place.geometry?.location) {
                            setFieldValue(
                              `deliveries[${index}].latitude`,
                              place.geometry.location.lat()
                            );
                            setFieldValue(
                              `deliveries[${index}].longitude`,
                              place.geometry.location.lng()
                            );
                          }

                          // Extract address components
                          const addressComponents =
                            place.address_components || [];
                          const getComponent = (type: string) => {
                            const component = addressComponents.find(
                              (comp: any) => comp.types.includes(type)
                            );
                            return component?.long_name || "";
                          };

                          const city =
                            getComponent("locality") ||
                            getComponent("administrative_area_level_2");
                          const state = getComponent(
                            "administrative_area_level_1"
                          );
                          const country = getComponent("country");

                          if (
                            values.accountType === "WITHIN_LAGOS" ||
                            values.accountType === "OUTSIDE_LAGOS"
                          ) {
                            setFieldValue(`deliveries[${index}].d_city`, city);
                            setFieldValue(
                              `deliveries[${index}].d_state`,
                              state
                            );
                          } else {
                            setFieldValue(`deliveries[${index}].d_city`, city);
                            setFieldValue(
                              `deliveries[${index}].d_state`,
                              state
                            );
                            setFieldValue(
                              `deliveries[${index}].d_state_b`,
                              country
                            );
                          }
                          console.log(values);
                          // Zone validation
                          const zone = getZone(
                            values.accountType!,
                            values.accountType === "OUTSIDE_NIGERIA"
                              ? country
                              : values.accountType === "OUTSIDE_LAGOS"
                              ? city
                              : state
                          );

                          if (!zone) {
                            toast.error(
                              `Service not available for delivery to this location. Please check your service type or enter a different address`
                            );
                            return;
                          }

                          const notAccepted = isLocationNotAccepted(
                            addressComponents,
                            values.accountType
                          );
                          if (notAccepted) {
                            toast.error("Delivery address not coverable");
                            return;
                          }
                        }}
                        onTimezoneOffsetFetched={(timezone) => {
                          setFieldValue(
                            `deliveries[${index}].timezone`,
                            timezone
                          );
                        }}
                        error={getFieldError(index, "d_address")}
                      />

                      {/* Geocoding Status Display */}
                      {delivery._geocodeWarning &&
                      (!delivery.latitude ||
                        !delivery.longitude ||
                        !delivery.d_address ||
                        !delivery.d_state ||
                        !delivery.d_city) ? (
                        <div className="md:col-span-2 flex items-start gap-2 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                          <ErrorInfo />
                          <div className="text-sm text-yellow-800 flex-1">
                            <p className="font-medium">
                              Address Update Notice:
                            </p>
                            <p>{delivery._geocodeWarning}</p>
                            {delivery._geocodeWarning.includes(
                              "approximate match"
                            ) && (
                              <p className="text-xs mt-1">
                                Please verify the address is correct for
                                accurate delivery.
                              </p>
                            )}
                            {(delivery._geocodeWarning.includes(
                              "Could not find"
                            ) ||
                              delivery._geocodeWarning.includes(
                                "Service not available"
                              )) && (
                              <p className="text-xs mt-1">
                                Try editing the address or click "Retry" to
                                attempt geocoding again.
                              </p>
                            )}
                          </div>
                          {/* {(delivery._geocodeWarning.includes(
                            "Could not find"
                          ) ||
                            delivery._geocodeWarning.includes(
                              "Service not available"
                            )) && (
                            <button
                              type="button"
                              onClick={() => retryGeocodeAddress(index)}
                              className="px-3 py-1 text-xs bg-yellow-600 text-white rounded hover:bg-yellow-700 transition-colors"
                            >
                              Retry
                            </button>
                          )} */}
                        </div>
                      ) : delivery.latitude &&
                        delivery.longitude &&
                        delivery.d_city &&
                        delivery.d_state ? (
                        <div className="md:col-span-2 flex items-start gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
                          <div className="w-4 h-4 bg-green-500 rounded-full mt-0.5 flex-shrink-0"></div>
                          <div className="text-sm text-green-800">
                            <p className="font-medium">Address Verified ✓</p>
                            <p className="text-xs mt-1">
                              Location: {delivery.d_city}, {delivery.d_state}
                            </p>
                          </div>
                        </div>
                      ) : null}

                      <div className="">
                        <Input
                          type="text"
                          name={`deliveries[${index}].d_city`}
                          label="City"
                          placeholder="City"
                          value={values.deliveries[index].d_city}
                        />

                        {/* <p className="text-[#fe7f1f] text-[10px] leading-[10px] mt-1 font-medium">
                          Note: Google may autofill the wrong city. Please check
                          and edit if needed
                        </p> */}
                      </div>

                      <Input
                        type="text"
                        name={`deliveries[${index}].d_state`}
                        label="State"
                        placeholder="State"
                        value={values.deliveries[index].d_state}
                      />

                      <Input
                        type="text"
                        name={`deliveries[${index}].email`}
                        label="Email"
                        required={false}
                        placeholder="Enter email"
                        value={values.deliveries[index].email}
                      />

                      <div className="flex flex-col gap-1">
                        <label className="text-sm text-greyscale-600">
                          Phone Number{" "}
                          <span className="text-alert-error-100">*</span>
                        </label>

                        <div
                          className={`w-full rounded-lg border bg-white h-12 px-6 flex items-center text-sm text-greyscale-900 focus:outline-none ${
                            !getFieldError(index, "d_phone_number")
                              ? "border-gray-100"
                              : "border-[#DF1C41] shadow-[0px_0px_1px_3px_rgba(223,28,65,0.15)]"
                          }`}
                        >
                          <PhoneInput
                            defaultCountry="ng"
                            value={delivery.d_phone_number}
                            disableDialCodeAndPrefix
                            onFocus={() =>
                              setFieldTouched(
                                `deliveries[${index}].d_phone_number`,
                                true,
                                true
                              )
                            }
                            onChange={(phone) => {
                              setFieldValue(
                                `deliveries[${index}].d_phone_number`,
                                phone
                              );
                            }}
                            countrySelectorStyleProps={{
                              buttonClassName:
                                "!border-0 !p-0 !m-0 hover:!bg-transparent",
                              dropdownStyleProps: {className: ""},
                            }}
                            inputClassName="w-full !border-0 !p-0 !m-0 hover:!bg-transparent"
                          />
                        </div>
                        {getFieldError(index, "d_phone_number") && (
                          <div className="flex items-center gap-1 mt-1">
                            <ErrorInfo />
                            <p className="text-xs font-semibold text-[#DF1C41]">
                              {getFieldError(index, "d_phone_number")}
                            </p>
                          </div>
                        )}
                      </div>

                      <div className="relative">
                        <Input
                          type="number"
                          name={`deliveries[${index}].d_weight`}
                          label="Product Weight (kg)"
                          placeholder="Enter product weight"
                          value={delivery.d_weight}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          min={0}
                          error={getFieldError(index, "d_weight")}
                        />
                        {/* <p className="absolute top-1 right-0 text-[10px] italic text-greyscale-400">
                          Max 15kg per item
                        </p> */}
                      </div>

                      <Input
                        type="number"
                        name={`deliveries[${index}].amount`}
                        label="Amount"
                        placeholder="Enter amount here"
                        value={delivery.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        min={0}
                        error={getFieldError(index, "amount")}
                      />

                      <div className="relative md:col-span-2">
                        <p className="absolute top-1 right-0 text-[10px] italic text-greyscale-400">
                          Max. 500 Characters
                        </p>
                        <Textarea
                          name={`deliveries[${index}].d_description`}
                          label="Item Details & Instructions"
                          placeholder="Enter details here…"
                          value={delivery.d_description}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={getFieldError(index, "d_description")}
                          note={true}
                        />
                      </div>
                      <div className="md:col-span-2 flex justify-end">
                        {index > 0 && (
                          <button
                            type="button"
                            onClick={() => removeDelivery(index)}
                            className="flex items-center gap-2.5 border border-alert-error-100 rounded-[10px] py-3 px-[18px] text-alert-error-100 font-bold text-sm"
                          >
                            <TrashLight />
                            Remove
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : uploadedDeliveries &&
              (results?.valid.length !== 0 || results?.invalid.length !== 0) ? (
              <div className="">
                <div className="mb-4 p-3 border border-black/20 rounded-lg text-sm text-greyscale-600">
                  Found{" "}
                  <strong>
                    <span className="text-alert-success-500">
                      {results?.valid.length} valid{" "}
                    </span>{" "}
                    and{" "}
                    <span className="text-alert-error-100">
                      {results?.invalid.length} invalid
                    </span>
                  </strong>{" "}
                  deliveries.
                </div>
                <TabGroup>
                  <div className="h-full flex flex-col">
                    <div className="flex justify-between items-center border-b border-b-[#E2E2E2]">
                      <div className=" w-full p-0">
                        <TabList className="grid grid-flow-col gap-4 py-0 cursor-pointer overflow-x-auto w-max">
                          <Tab
                            key="valid"
                            className={({selected}) =>
                              `pb-1 px-2 focus:outline-none font-semibold text-sm ${
                                selected
                                  ? "text-greyscale-700 bg-transparent border-b-2 border-greyscale-700"
                                  : "border-b-2 border-transparent text-greyscale-400"
                              }`
                            }
                            onClick={() => setActiveTab("valid")}
                          >
                            Valid
                          </Tab>
                          <Tab
                            key="invalid"
                            onClick={() => setActiveTab("invalid")}
                            className={({selected}) =>
                              `pb-1 px-2 focus:outline-none font-semibold text-sm ${
                                selected
                                  ? "text-greyscale-700 bg-transparent border-b-2 border-greyscale-700"
                                  : "border-b-2 border-transparent text-greyscale-400"
                              }`
                            }
                          >
                            Invalid
                          </Tab>
                        </TabList>
                      </div>

                      {activeTab === "valid" &&
                        results?.valid &&
                        results.valid.length > 0 && (
                          <button
                            className="flex items-center gap-2 border border-black/50 rounded-lg p-1 mb-1"
                            type="button"
                            onClick={() => {
                              // Remove all valid addresses
                              setResults({
                                ...results,
                                valid: [],
                              });
                              setTotalValid(0);
                              setTotalCount(results.invalid.length);
                              toast.success("All valid addresses removed");
                            }}
                          >
                            <Trash />
                            <p className="text-xs w-max">Remove all</p>
                          </button>
                        )}
                      {activeTab === "invalid" &&
                        results?.invalid &&
                        results.invalid.length > 0 && (
                          <div className="flex gap-3">
                            <button
                              className="flex items-center gap-2 border border-black/50 rounded-lg p-1 mb-1"
                              type="button"
                              onClick={() =>
                                downloadInvalidCSV(results.invalid)
                              }
                            >
                              <span className="scale-75">
                                <Download />
                              </span>
                              <p className="text-xs w-max">
                                Download Invalid Deliveries
                              </p>
                            </button>
                            <button
                              className="flex items-center gap-2 border border-black/50 rounded-lg p-1 mb-1"
                              type="button"
                              onClick={() => {
                                setResults({
                                  ...results,
                                  invalid: [],
                                });
                                setTotalInvalid(0);
                                setTotalCount(results.valid.length);
                                toast.success("All invalid addresses removed");
                              }}
                            >
                              <Trash />
                              <p className="text-xs w-max">Remove all</p>
                            </button>
                          </div>
                        )}
                    </div>

                    <TabPanels className="mt-1">
                      <TabPanel key={"valid"}>
                        <div>
                          {results?.valid && results.valid.length > 0 ? (
                            <div className="overflow-x-auto">
                              <table className="w-full border-collapse">
                                <thead>
                                  <tr className="border-b border-b-[#eaecf0] bg-[#f9fafb]">
                                    <th className="p-3 text-left text-sm font-medium text-[#667085] min-w-[100px]">
                                      Full Name
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Address
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      City
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      State
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Email
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Phone number
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Weight
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Item Desc.
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Amount
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Action
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {results.valid.map((item, index) => (
                                    <tr
                                      key={index}
                                      className="border-b border-gray-100 hover:bg-greyscale-50"
                                    >
                                      <td className="p-3 text-sm">
                                        {item["Full Name"] || ""}
                                      </td>
                                      <td className="p-3 text-sm min-w-[180px]">
                                        {item.Address || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item.City || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item.State || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item.Email || ""}
                                      </td>

                                      <td className="p-3 text-sm">
                                        {item["Phone Number"] || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item["Product Weight"] || ""}
                                      </td>
                                      <td className="p-3 text-sm min-w-[150px]">
                                        {item[
                                          "Item Description & Instruction"
                                        ] || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {Number(
                                          item["Amount"]
                                        ).toLocaleString() || ""}
                                      </td>

                                      <td className="p-3 flex gap-3">
                                        <button
                                          onClick={() => {
                                            setEditingIndex(index);
                                            setEditingAddress({...item});
                                            setEditingType("valid");
                                          }}
                                          type="button"
                                          className="text-[#fe7f1f] hover:text-primary-400 w-6 h-5"
                                        >
                                          <OrderEdit />
                                        </button>

                                        <button
                                          onClick={() => {
                                            const newValid = [...results.valid];
                                            newValid.splice(index, 1);
                                            setResults({
                                              ...results,
                                              valid: newValid,
                                            });
                                            setTotalValid(newValid.length);
                                            setTotalCount(
                                              newValid.length +
                                                (results?.invalid?.length || 0)
                                            );
                                          }}
                                          className="text-alert-error-100 hover:text-alert-error-200"
                                        >
                                          <Trash />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-center py-8 text-greyscale-400">
                              No valid deliveries
                            </div>
                          )}
                        </div>
                      </TabPanel>
                      <TabPanel key={"invalid"}>
                        <div>
                          {results?.invalid && results.invalid.length > 0 ? (
                            <div className="overflow-x-auto">
                              <table className="w-full border-collapse">
                                <thead>
                                  <tr className="border-b border-b-[#eaecf0] bg-[#f9fafb]">
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Status
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085] min-w-[100px]">
                                      Full Name
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Address
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      City
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      State
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Email
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Phone number
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Weight
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Item Desc.
                                    </th>
                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Amount
                                    </th>

                                    <th className="p-3 text-left text-sm font-medium text-[#667085]">
                                      Actions
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {results.invalid.map((item, index) => (
                                    <tr
                                      key={index}
                                      className="border-b border-gray-100 hover:bg-greyscale-50"
                                    >
                                      <td className="p-3">
                                        <div className="relative group">
                                          <ErrorInfo />
                                          <div className="!absolute !left-6 !top-0 !w-64 !p-3 bg-gray-800 text-white text-xs rounded-lg opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none z-10">
                                            {item._validationError}
                                          </div>
                                        </div>
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item["Full Name"] || ""}
                                      </td>
                                      <td className="p-3 text-sm min-w-[180px]">
                                        {item.Address || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item.City || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item.State || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item.Email || ""}
                                      </td>

                                      <td className="p-3 text-sm">
                                        {item["Phone Number"] || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {item["Product Weight"] || ""}
                                      </td>
                                      <td className="p-3 text-sm min-w-[150px]">
                                        {item[
                                          "Item Description & Instruction"
                                        ] || ""}
                                      </td>
                                      <td className="p-3 text-sm">
                                        {Number(
                                          item["Amount"]
                                        ).toLocaleString() || ""}
                                      </td>
                                      <td className="p-3 flex gap-2 min-w-max">
                                        <button
                                          onClick={() => {
                                            setEditingIndex(index);
                                            setEditingAddress({...item});
                                            setEditingType("invalid");
                                          }}
                                          type="button"
                                          className="text-[#fe7f1f] hover:text-primary-400 w-6 h-5"
                                        >
                                          <OrderEdit />
                                        </button>
                                        <button
                                          onClick={() => {
                                            const newInvalid = [
                                              ...results.invalid,
                                            ];
                                            newInvalid.splice(index, 1);
                                            setResults({
                                              ...results,
                                              invalid: newInvalid,
                                            });
                                            setTotalInvalid(newInvalid.length);
                                            setTotalCount(
                                              (results?.valid?.length || 0) +
                                                newInvalid.length
                                            );
                                          }}
                                          type="button"
                                          className="text-alert-error-100 hover:text-alert-error-200"
                                        >
                                          <Trash />
                                        </button>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <div className="text-center py-8 text-greyscale-400">
                              No invalid deliveries
                            </div>
                          )}
                        </div>
                      </TabPanel>
                    </TabPanels>
                  </div>
                </TabGroup>
                {/* Edit Modal for Invalid Addresses */}
                {editingIndex !== null && editingAddress && (
                  <div className="fixed inset-0 bg-black/15 bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-lg p-6 w-full max-w-md">
                      <h3 className="font-semibold text-lg mb-4">
                        Edit Delivery Details
                      </h3>

                      <div className="grid grid-cols-2 gap-4">
                        <Input
                          name="newadd"
                          type="text"
                          label="Full Name"
                          value={editingAddress["Full Name"] || ""}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              "Full Name": e.target.value,
                            })
                          }
                        />
                        <Input
                          name="newem"
                          type="email"
                          required={false}
                          label="Email"
                          value={editingAddress.Email || ""}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              Email: e.target.value,
                            })
                          }
                        />

                        <AddressInput
                          name="new"
                          label="Address"
                          regionScope={
                            values.accountType === "OUTSIDE_NIGERIA"
                              ? "international"
                              : "nigeria"
                          }
                          placeholder="Search your address"
                          value={editingAddress.Address || ""}
                          onPlaceSelected={(place) => {
                            const addressComponents =
                              place.address_components || [];
                            const getComponent = (type: string) => {
                              const component = addressComponents.find(
                                (comp: any) => comp.types.includes(type)
                              );
                              return component?.long_name || "";
                            };

                            const city =
                              getComponent("locality") ||
                              getComponent("administrative_area_level_2");
                            const state = getComponent(
                              "administrative_area_level_1"
                            );
                            const country = getComponent("country");

                            setEditingAddress({
                              ...editingAddress,
                              Address: place.formatted_address || "",
                              City: city,
                              State: state,
                              Country: country,
                              latitude: place?.geometry?.location?.lat() || 0,
                              longitude: place?.geometry?.location?.lng() || 0,
                              timezone: getTimezoneOffset(
                                place?.geometry?.location?.lat()!,
                                place?.geometry?.location?.lng()!
                              ),
                            });
                          }}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              Address: e.target.value,
                            })
                          }
                        />

                        <Input
                          name="newci"
                          type="text"
                          label="City"
                          value={editingAddress.City || ""}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              City: e.target.value,
                            })
                          }
                        />

                        <Input
                          name="newst"
                          type="text"
                          label="State"
                          value={editingAddress.State || ""}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              State: e.target.value,
                            })
                          }
                        />

                        <div className="flex flex-col gap-1">
                          <label className="text-sm text-greyscale-600">
                            Phone Number{" "}
                            <span className="text-alert-error-100">*</span>
                          </label>

                          <div
                            className={`w-full rounded-lg border bg-white h-12 px-6 flex items-center text-sm text-greyscale-900 focus:outline-none ${
                              !phoneError
                                ? "border-gray-100"
                                : "border-[#DF1C41] shadow-[0px_0px_1px_3px_rgba(223,28,65,0.15)]"
                            }`}
                          >
                            <PhoneInput
                              defaultCountry="ng"
                              value={editingAddress["Phone Number"] || ""}
                              disableDialCodeAndPrefix
                              onChange={(phone) => {
                                setEditingAddress({
                                  ...editingAddress,
                                  "Phone Number": phone,
                                });

                                // Reset error when user starts typing
                                if (phoneError) {
                                  setPhoneError("");
                                }
                              }}
                              onBlur={() => {
                                if (!editingAddress["Phone Number"]?.trim()) {
                                  setPhoneError("Phone number is required");
                                  return;
                                }

                                const isValid = validatePhoneNumber(
                                  editingAddress["Phone Number"]
                                );
                                setPhoneError(
                                  isValid ? "" : "Invalid phone number format"
                                );
                              }}
                              countrySelectorStyleProps={{
                                buttonClassName:
                                  "!border-0 !p-0 !m-0 hover:!bg-transparent",
                                dropdownStyleProps: {className: ""},
                              }}
                              inputClassName="w-full !border-0 !p-0 !m-0 hover:!bg-transparent"
                            />{" "}
                          </div>
                          {phoneError && (
                            <div className="flex items-center gap-1 mt-1">
                              <ErrorInfo />
                              <p className="text-xs font-semibold text-[#DF1C41]">
                                {phoneError}
                              </p>
                            </div>
                          )}
                        </div>
                        <Input
                          name="newpw"
                          type="text"
                          label="Product Weight"
                          value={editingAddress["Product Weight"] || ""}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              "Product Weight": e.target.value,
                            })
                          }
                        />

                        <Input
                          name="newam"
                          type="number"
                          label="Amount"
                          value={editingAddress["Amount"] || ""}
                          onChange={(e) =>
                            setEditingAddress({
                              ...editingAddress,
                              Amount: e.target.value,
                            })
                          }
                        />

                        <div className="col-span-2">
                          <Textarea
                            name="newnt"
                            type="text"
                            label="Item Description & Instruction"
                            value={
                              editingAddress[
                                "Item Description & Instruction"
                              ] || ""
                            }
                            onChange={(e) =>
                              setEditingAddress({
                                ...editingAddress,
                                "Item Description & Instruction":
                                  e.target.value,
                              })
                            }
                          />
                        </div>
                      </div>

                      <div className="flex justify-end gap-3 mt-6">
                        <button
                          onClick={() => {
                            setEditingIndex(null);
                            setEditingAddress(null);
                            setEditingType(null);
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          className={
                            "!bg-[#fe7f1f]  !rounded-lg !text-white !text-sm !py-2 !px-4"
                          }
                          type="button"
                          onClick={async () => {
                            if (!editingAddress["Phone Number"]?.trim()) {
                              setPhoneError("Phone number is required");
                              toast.error("Please enter a valid phone number");
                              return;
                            }
                            if (
                              !editingAddress["Amount"] ||
                              Number(editingAddress["Amount"]) < 1
                            ) {
                              toast.error(
                                "Amount is required and must be greater than 0"
                              );
                              return;
                            }
                            const isPhoneValid = validatePhoneNumber(
                              editingAddress["Phone Number"]
                            );
                            if (!isPhoneValid) {
                              setPhoneError("Invalid phone number format");
                              toast.error("Please enter a valid phone number");
                              return;
                            }

                            // Clear phone error if valid
                            setPhoneError("");

                            const addressForValidation = {
                              Address: editingAddress.Address || "",
                              City: editingAddress.City || "",
                              State: editingAddress.State || "",
                              Country: editingAddress.Country || "",
                              // Add weight field if needed
                              Weight: editingAddress["Product Weight"] || "",
                            };

                            const validationResult = await validateAddress(
                              addressForValidation,
                              values.accountType === "WITHIN_LAGOS"
                                ? "within-lagos"
                                : values.accountType === "OUTSIDE_LAGOS"
                                ? "outside-lagos"
                                : "outside-nigeria",
                              values.accountType,
                              editingAddress["Product Weight"]
                                ? Number(editingAddress["Product Weight"])
                                : undefined
                            );

                            if (editingType === "valid") {
                              // Update existing valid address
                              const newValid = [...results!.valid];
                              if (validationResult.isValid) {
                                // Address is still valid after editing - update the existing record
                                newValid[editingIndex!] = {
                                  ...editingAddress, // Use the edited address with updated values
                                  // Update with any geocoded data if available
                                  ...(validationResult.addressData || {}),
                                };
                                setResults({
                                  ...results!,
                                  valid: newValid,
                                });
                                toast.success("Delivery updated successfully");
                              } else {
                                // Address became invalid after editing, move to invalid
                                newValid.splice(editingIndex!, 1);
                                setResults({
                                  valid: newValid,
                                  invalid: [
                                    ...results!.invalid,
                                    {
                                      ...editingAddress, // Use the edited address with updated values
                                      _validationError: validationResult.reason,
                                    },
                                  ],
                                });
                                setTotalValid(newValid.length);
                                setTotalInvalid(results!.invalid.length + 1);
                                toast.error(
                                  "Address is now invalid: " +
                                    validationResult.reason
                                );
                              }
                            } else if (editingType === "invalid") {
                              // Update existing invalid address
                              const newInvalid = [...results!.invalid];
                              if (validationResult.isValid) {
                                // Address became valid after editing, move to valid
                                newInvalid.splice(editingIndex!, 1);
                                // Remove the validation error field and use the edited address
                                const {_validationError, ...validAddress} =
                                  editingAddress;
                                setResults({
                                  valid: [...results!.valid, validAddress], // Use the edited address
                                  invalid: newInvalid,
                                });
                                setTotalValid(results!.valid.length + 1);
                                setTotalInvalid(newInvalid.length);
                                toast.success("Address is now valid");
                              } else {
                                // Address is still invalid after editing - update with edited values and new error
                                // newInvalid[editingIndex!] = {
                                //   ...editingAddress, // Use the edited address with updated values
                                //   _validationError: validationResult.reason,
                                // };
                                // setResults({
                                //   ...results!,
                                //   invalid: newInvalid,
                                // });
                                toast.error(
                                  "Address is still invalid: " +
                                    validationResult.reason
                                );
                                return;
                              }
                            }

                            setEditingIndex(null);
                            setEditingAddress(null);
                            setEditingType(null);
                          }}
                        >
                          Save Changes
                        </button>{" "}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="border border-black/[4%] rounded-[20px] py-6 px-4">
                <p className="font-semibold mb-4">Import Order</p>

                <label className="flex flex-col items-center gap-4 justify-center w-full h-[197px] bg-black/[2%] border border-black/[8%] rounded-[10px] mb-6 cursor-pointer">
                  <input
                    type="file"
                    accept=".xlsx,.csv"
                    onChange={handleFileChange}
                    className="hidden"
                  />
                  <BigDocs />
                  <p className="text-sm font-semibold">
                    Drop your file here or{" "}
                    <span className="text-[#fe7f1f] underline">Browse</span>
                  </p>
                  <p className="text-xs text-greyscale-300">
                    Max. file size must be 2MB (Supported format .XLS, .CSV)
                  </p>
                </label>
                {uploadProgress > 0 && (
                  <div className="mt-2 mb-4 w-full bg-orange-100 h-2 rounded overflow-hidden">
                    <div
                      className="bg-orange-500 h-2 rounded relative"
                      style={{width: `${uploadProgress}%`}}
                    >
                      <div className="absolute inset-0 bg-[linear-gradient(45deg,rgba(255,255,255,0.4)_25%,transparent_25%,transparent_50%,rgba(255,255,255,0.4)_50%,rgba(255,255,255,0.4)_75%,transparent_75%,transparent)] bg-[length:20px_20px] animate-[moveStripes_1s_linear_infinite]" />
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-between">
                  <div>
                    <div className="flex items-center gap-2">
                      <SmallDocs />
                      <p className="font-semibold text-xs text-greyscale-600">
                        Document Sample
                      </p>
                    </div>
                    <p className="font-semibold text-xs text-greyscale-400">
                      You can download the attached sample and use it as a guide
                      to create yours.
                    </p>
                  </div>

                  <a
                    href={fileData[values.accountType].path}
                    download={fileData[values.accountType].name}
                    className="block ml-6 py-3 px-4 bg-transparent border border-black font-medium rounded-lg transition duration-200 flex items-center justify-center"
                  >
                    Download
                  </a>
                </div>

                <div className="mt-4 p-4 shadow border rounded-xl border-gray-500 text-greyscale-600">
                  <p className="text-xs">
                    <strong>Guide for Filling Bulk Upload Template.</strong>{" "}
                    <br /> Field Instructions for Bulk Upload Template
                  </p>
                  <ul className="text-xs list-disc ml-4">
                    <li>
                      <strong>Name → </strong>Enter the recipient’s full legal
                      name (first name and surname).
                    </li>
                    <li>
                      <strong>Address → </strong>Provide the complete delivery
                      address. For international shipments, make sure to include
                      the postal code.
                    </li>
                    <li>
                      <strong>City → </strong>Enter the destination city exactly
                      as it is recognized locally.
                    </li>
                    <li>
                      <strong>State/Province → </strong>Provide the state,
                      province, or region (if applicable) for accurate delivery.
                    </li>
                    <li>
                      <strong>Item Description & Instruction → </strong>Use this
                      section to:
                      <ul className="list-disc ml-4">
                        <li> Describe the item(s) being shipped.</li>
                        <li>Declare the item’s value.</li>
                        <li> Indicate if insurance is required.</li>
                        <li>
                          Add any special delivery instructions (e.g., fragile,
                          deliver after 5 PM).
                        </li>
                      </ul>
                    </li>
                    <li>
                      <strong>Weight → </strong>Enter the accurate weight (in
                      kg) of the shipment. This is required for calculating
                      freight cost.
                    </li>
                  </ul>
                </div>
              </div>
            )}

            <div className="flex justify-between gap-2 w-full mt-6">
              {values.orderType === "BATCH_ORDER" && orderType === "manual" && (
                <div className="flex gap-2 md:gap-4">
                  <button
                    type="button"
                    onClick={addDelivery}
                    className="border border-black text-xs flex rounded-lg items-center md:text-sm px-2 md:px-4"
                  >
                    Add Another Delivery
                  </button>

                  <button
                    type="button"
                    onClick={duplicateDelivery}
                    className="border border-black flex rounded-lg items-center gap-2 md:gap-4 text-xs md:text-sm px-2 md:px-4"
                  >
                    <CopyBlack />
                    Duplicate
                  </button>
                </div>
              )}

              {/* Test Google Places API Button */}
              {/* {values.orderType === "BATCH_ORDER" && orderType === "manual" && (
                <Button
                  variant={"outlined"}
                  type="button"
                  onClick={testGooglePlacesAPI}
                  className="border-blue-600 text-blue-600 text-xs md:text-base px-2 md:px-4"
                >
                  Test API
                </Button>
              )} */}

              <button
                type="button"
                onClick={handleEstimateClick}
                className={
                  "!bg-[#fe7f1f]  !rounded-lg !text-white ml-auto text-sm !py-2 !px-4"
                }
              >
                Estimate Cost
              </button>
            </div>
          </>
        )}
      </div>
    );
  }
);

DeliveryDetails.displayName = "DeliveryDetails";
